import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"];
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef, useContext, useRef, useEffect } from 'react';
import { PopoverOverflowContext } from './popover-overflow-context.js';
import styles from './popover.module.js';
/**
 * Container to hold the main content for the popover
 */

var PopoverMainContent = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var _useContext = useContext(PopoverOverflowContext),
      isContentOverflowing = _useContext.isContentOverflowing,
      setIsContentOverflowing = _useContext.setIsContentOverflowing;

  var outerContainerRef = useRef(null);
  var innerContainerRef = useRef(null); // checks if content is overflowing whenever the content (children) changes, e.g. if new fields are added based on selection

  useEffect(function () {
    var _outerContainerRef$cu, _innerContainerRef$cu;

    var outerContainerHeight = ((_outerContainerRef$cu = outerContainerRef.current) === null || _outerContainerRef$cu === void 0 ? void 0 : _outerContainerRef$cu.clientHeight) || 0;
    var innerContainerHeight = ((_innerContainerRef$cu = innerContainerRef.current) === null || _innerContainerRef$cu === void 0 ? void 0 : _innerContainerRef$cu.scrollHeight) || 0;
    setIsContentOverflowing && setIsContentOverflowing(innerContainerHeight > outerContainerHeight);
  }, [children, setIsContentOverflowing]);
  return jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx(styles.popoverMainContent, className, isContentOverflowing ? styles.popoverMainContentBottomMargin : ''),
    children: jsx("div", {
      ref: outerContainerRef,
      className: styles.popoverMainContentOuterContainer,
      children: jsx("div", {
        ref: innerContainerRef,
        className: isContentOverflowing ? styles.popoverMainContentInnerContainerPadding : '',
        children: children
      })
    })
  }));
});
PopoverMainContent.displayName = 'PopoverMainContent';
export { PopoverMainContent };